import React from "react";
const ThumbsUpIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width="14"
      height="14"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M7 2.71C7 4.477 5.308 4.866 4.516 5.87c-.487.62-.677 1.806-.677 1.806v5.194C5.182 13.341 6.096 14 8.806 14c2.164-.021 2.54-.045 3.388-.903.903-.903 1.806-4.39 1.806-6.323 0-.15-.04-.322-.08-.514-.198-.934-1.401-1.129-2.404-1.129-.718 0-1.401.11-1.423.11-.214 0-.315-.299-.226-.527.266-.684.294-1.755.294-2.908C10.161 0 8.581 0 8.581 0S7 0 7 2.71Z"
          fill="#FFD60B"
        />
        <path
          d="m4.122 12.763 1.516.785 2.565.34h1.985l1.61-.822 1.469-4.105V7.484c-.558 2.76-1.498 4.33-2.818 4.71-1.32.38-3.408.145-6.265-.702l-.062 1.271Z"
          fill="#FFB000"
        />
        <path
          d="m4.516 6.473 1.659-1.416.967-1.495.365-2.419L8.695.341l1.088.525-.14 1.328c-.231-.748-.577-1.001-1.037-.759-.69.364.198 3.188-1.653 4.131-1.851.943-2.83 3.42-2.83 4.836V7.398l.393-.925Z"
          fill="#FFEB97"
        />
        <path
          d="M8.57.34c.155.007.614.055.932.425.19.22.32.553.32 1.041 0 1.103-.015 2.13-.27 2.785.518.815 1.092.876 1.713.88h.251c.518 0 1.098.049 1.534.254.256.12.462.297.532.579.069 2.345-.761 5.687-1.63 6.555-.787.797-1.156.783-3.146.802-1.968 0-2.958-.358-3.878-.73a37.501 37.501 0 0 0-.75-.297v-4.93c.028-.168.2-1.11.605-1.624.241-.306.576-.548.912-.797.83-.613 1.644-1.26 1.644-2.573 0-.815.148-1.364.36-1.73.31-.539.758-.63.87-.64Z"
          stroke="#975F00"
          strokeWidth=".677"
        />
        <rect
          stroke="#975F00"
          strokeWidth=".677"
          fill="#FFF"
          x=".339"
          y="6.339"
          width="3.839"
          height="7.323"
          rx="1.129"
        />
        <path
          d="M.677 11.516c0 .25.203.452.452.452h2.258c.25 0 .452-.202.452-.452v1.355c0 .25-.202.452-.452.452H1.13a.452.452 0 0 1-.452-.452Z"
          fill="#CCC"
        />
      </g>
    </svg>
  )
);
ThumbsUpIcon.displayName = "ThumbsUpIcon";
export default ThumbsUpIcon;
